import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Skeleton as AbyssSkeleton } from '@uhg-abyss/web/ui/Skeleton';
import { motion } from 'framer-motion';
import React from 'react';

/**
 * Skeleton
 *
 * @returns {Element}
 * @constructor
 */
export function Skeleton() {
  return (
    <ErrorHandler location="src/layouts/Dashboard/sections/Header/components/Skeleton/Skeleton.jsx">
      <motion.div
        animate="open"
        initial={{ opacity: 0 }}
        variants={{
          closed: { opacity: 0 },
          open: { opacity: 1 },
        }}
      >
        <Grid>
          <Grid.Col
            span={{
              xs: '100%',
            }}
          >
            <Layout.Stack alignItems="left" grow>
              <AbyssSkeleton data-testid="header-skeleton" height="125px" width="100%" />
            </Layout.Stack>
          </Grid.Col>
        </Grid>
      </motion.div>
    </ErrorHandler>
  );
}
